export default "__VITE_ASSET__CCqHz8Vv__"